import { Backdrop, CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

import { Register } from '../components/common'
import PreLoginLayout from '../components/common/PreLoginLayout'
import initFirebase from '../db/initFirebase'
import Database from '../types/Database'

import routes from './routes'

const Signup = () => {
  const [LoggedInUser, setLoggedInUser] = useState<Database.User | undefined>(
    undefined
  )
  const [isChecking, setIsChecking] = useState<boolean>(true)
  const [userCreationComplete, setUserCreationComplete] =
    useState<boolean>(false)

  useEffect(() => {
    const unsubscribe = initFirebase
      .getFireBaseStore()
      .auth.onAuthStateChanged(function (
        user: Database.User | undefined | null
      ) {
        console.log(
          'Signup page - auth state changed:',
          user ? 'logged in' : 'logged out'
        )
        if (user) {
          setLoggedInUser(user)
        }
        setIsChecking(false)
      })

    return () => unsubscribe()
  }, [])

  // Poll for user creation completion
  useEffect(() => {
    if (!LoggedInUser) return undefined

    const checkInterval = setInterval(() => {
      const isComplete = localStorage.getItem('userCreationComplete')
      if (isComplete === 'true') {
        console.log('✅ User creation complete, ready to redirect')
        localStorage.removeItem('userCreationComplete')
        setUserCreationComplete(true)
        clearInterval(checkInterval)
      }
    }, 100) // Check every 100ms

    // Timeout after 10 seconds
    const timeout = setTimeout(() => {
      console.log('⚠️  User creation timeout, redirecting anyway')
      clearInterval(checkInterval)
      setUserCreationComplete(true)
    }, 10000)

    return () => {
      clearInterval(checkInterval)
      clearTimeout(timeout)
    }
  }, [LoggedInUser])

  // If user is logged in AND user creation is complete, redirect
  if (LoggedInUser && userCreationComplete) {
    console.log('Signup page - redirecting to home')
    return (
      <>
        <Backdrop
          sx={{
            color: theme => (theme.palette.mode === 'dark' ? '#fff' : '#000'),
            zIndex: 9999,
            position: 'fixed',
            backgroundColor: theme =>
              theme.palette.mode === 'dark'
                ? 'rgba(0, 0, 0, 0.95)'
                : 'rgba(255, 255, 255, 0.95)'
          }}
          open={true}
        >
          <CircularProgress color='inherit' size={60} />
        </Backdrop>
        <Navigate to={routes.home} replace />
      </>
    )
  }

  // Show loading while checking auth state
  if (isChecking) {
    return (
      <Backdrop
        sx={{
          color: theme => (theme.palette.mode === 'dark' ? '#fff' : '#000'),
          zIndex: 9999,
          position: 'fixed',
          backgroundColor: theme =>
            theme.palette.mode === 'dark'
              ? 'rgba(0, 0, 0, 0.95)'
              : 'rgba(255, 255, 255, 0.95)'
        }}
        open={true}
      >
        <CircularProgress color='inherit' size={60} />
      </Backdrop>
    )
  }

  return (
    <PreLoginLayout>
      {!LoggedInUser && <Register />}
      {LoggedInUser && <Navigate to={routes.home} />}
    </PreLoginLayout>
  )
}

export default Signup
